import type { JSX } from 'react'
import type { ILabelProps } from '../Label'

import { COLOR } from 'vars/index'
import { Label } from '../Label'
import { Backgrounds, Fonts, Paddings } from '../Label.h'

export interface ILabelWarningProps extends ILabelProps {}

export const LabelWarning = ({
  title = '',
  background = Backgrounds.ADDITIONAL_RED_2,
  padding = Paddings.SIZE_30,
  font = Fonts.Caption4,
  color = COLOR.TEXT_ICON_CONSTANT_LIGHT,
  ...rest
}: ILabelWarningProps): JSX.Element => (
  <Label
    title={title}
    background={background}
    padding={padding}
    font={font}
    color={color}
    {...rest}
  />
)
